import { Outlet, useLocation } from 'react-router'
import styled from 'styled-components'
import AppHeader from '../components/common/AppHeader'
import ButtonPanel from '../components/dashboard/ButtonPanel'
import { HeaderProvider, useHeaderContext } from '../contexts/HeaderContext'
import { findRouteByPath } from '../router/route-utils'

const MainContainer = styled.div<{ $hasButtonPanel?: boolean }>`
  max-width: 24.5625rem;
  margin: 0 auto;
  padding-bottom: ${props => (props.$hasButtonPanel ? '5.5rem' : '0')};
  background: white;
  min-height: 53.25rem;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  @media screen and (max-width: 37.5rem) {
    max-width: none;
    padding-bottom: ${props => (props.$hasButtonPanel ? '3.75rem' : '0')};
  }
`

const ContentArea = styled.div`
  flex: 1;
  overflow-y: auto;
`

function MainLayoutContent() {
  const location = useLocation()
  const { dynamicTitle } = useHeaderContext()

  // Get header configuration from unified route definitions
  const routeInfo = findRouteByPath(location.pathname)
  const defaultConfig = {
    variant: 'default' as const,
    sticky: false,
    border: true,
    title: undefined,
    showSearch: false,
  }

  const headerConfig = routeInfo?.definition.header
    ? { ...defaultConfig, ...routeInfo.definition.header }
    : defaultConfig

  // 동적 제목이 있으면 우선 사용, 없으면 정적 설정 사용
  const finalTitle = dynamicTitle !== undefined ? dynamicTitle : headerConfig.title

  // ButtonPanel을 표시할 경로들 (정확한 경로만 매칭)
  const showButtonPanel =
    location.pathname === '/' ||
    location.pathname === '/campaign' ||
    location.pathname === '/profile'

  return (
    <MainContainer $hasButtonPanel={showButtonPanel}>
      <AppHeader
        variant={headerConfig.variant}
        title={finalTitle}
        sticky={headerConfig.sticky}
        border={headerConfig.border}
        backTo={headerConfig.backTo}
      />
      <ContentArea>
        <Outlet />
      </ContentArea>
      {showButtonPanel && <ButtonPanel />}
    </MainContainer>
  )
}

export default function MainLayout() {
  return (
    <HeaderProvider>
      <MainLayoutContent />
    </HeaderProvider>
  )
}
